import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { GradientButtonOutline } from "components/GradientButton";
import TableModal from "components/TableExplanded/TableModal";
import { QRCodeCanvas } from "qrcode.react";

const categoryOptions = [
  { label: "Category 1", id: 1 },
  { label: "Category 2", id: 2 },
  { label: "Category 3", id: 3 },
];

const productFields = [
  { label: "QR Code", name: "qrcode" },
  { label: "รหัสสินค้า", name: "product_code" },
  { label: "ชื่อสินค้า", name: "product_name" },
  { label: "หมวดหมู่", name: "category" },

  { label: "รายละเอียด", name: "detail" },
  { label: "ตำหนิ", name: "blemishes" },
  { label: "ขนาด", name: "size" },
  { label: "จำนวน", name: "total_amount" },
  { label: "ราคาทุน/ชิ้น", name: "price" },
  { label: "ราคารวม", name: "total_price" },
];

// const customerFields = [
//   { label: "ชื่อ-นามสกุล", name: "customer_name" },
//   { label: "เลขบัตรประชาชน", name: "idcard" },
//   { label: "เบอร์โทรศัพท์", name: "customer_phonenumber" },
//   { label: "ที่อยู่", name: "customer_address" },
// ];

const ModalView = ({ open, onClose, viewProduct }) => {
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  useEffect(() => {
    if (
      viewProduct &&
      viewProduct.picture &&
      Array.isArray(viewProduct.picture)
    ) {
      const productImageUrls = viewProduct.picture.map((img) => img);
      setInitialProductUrls(productImageUrls);
    }
  }, [viewProduct]);

  const handleClose = () => {
    onClose();
    setInitialProductUrls([]);
  };

  const renderFields = (fields, values) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={2}>
          <Typography variant="subtitle1">{field.label}</Typography>
        </Grid>
        <Grid item xs={12} sm={10}>
          {field.name === 'qrcode' ? 
            <QRCodeCanvas
              value={values[field.name]} // ดึงค่าจาก formik และใช้ค่าที่ว่างเป็นค่า default ถ้าไม่พบ
              size={64} // ขนาดของ QR Code
              bgColor={"#ffffff"} // สีพื้นหลัง
              fgColor={"#000000"} // สีของ QR Code
              level={"H"} // ระดับการกู้คืนข้อมูล (L, M, Q, H)
            /> :
          <Typography variant="body1">
            {field.name === "category_id"
              ? (() => {
                  const category = categoryOptions.find((category) => {
                    return category.id === values.category;
                  });
                  // console.log("found category", category);
                  return category?.label || "";
                })()
              : values[field.name]}
          </Typography>}
        </Grid>
      </React.Fragment>
    ));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{
        borderRadius: "8px",
      }}
    >
      <DialogTitle>
        <Typography variant="h4">รายละเอียดสินค้า</Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <Grid container spacing={3} sx={{ padding: 3 }}>
          <Grid item xs={12}>
            <Typography sx={{ mb: 3 }} variant="h4">
              ข้อมูลสินค้า
            </Typography>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              {renderFields(productFields, viewProduct || {})}
              <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ mb: 2 }}>
                  รูปทรัพย์
                </Typography>
                {initialProductUrls.map((url, index) => (
                  <img
                    key={index}
                    src={url.picture}
                    alt={`Product ${index}`}
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                      marginRight: "10px",
                    }}
                  />
                ))}
              </Grid>
            </Grid>
            {/* <Typography sx={{ mb: 3 }} variant="h4">
              ข้อมูลผู้ขาย
            </Typography>
            <Grid container spacing={2}>
              {renderFields(customerFields, viewProduct || {})}
              <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ mb: 2 }}>
                  รูปหน้าบัตรประชาชน
                </Typography>
                {viewProduct?.customer_image && (
                  <img
                    src={viewProduct.customer_image}
                    alt="Preview"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                )}
              </Grid>
            </Grid> */}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <GradientButtonOutline
          variant="outlined"
          sx={{ mr: 1 }}
          onClick={() => handleClose()}
        >
          กลับ
        </GradientButtonOutline>
      </DialogActions>
    </Dialog>
  );
};

export default ModalView;
